import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import './RadioButton.scss';
import PlanSpeedIndecator from '../Plans/PlanSpeedIndecator/PlanSpeedIndecator';
import PlanDealInfoPopup from '../Plans/PlanDetails/PlanDealInfoPopup';

const RadioButton = (props) => {
  const radioProps = omit(props, 'previousPrice', 'price',
    'additionalText2', 'description', 'isSpecial', 'planStateText',
    'upload', 'download', 'planType');
  const stateClass = radioProps.disabled ? 'plan-text-disabled' : '';
  const dealClass = props.isSpecial ? 'special-deal' : '';
  return (
    <div className={'row'}>
      <div className="col-sm-9 relative radio-main-content">
        <input
          type="radio"
          className={'radio-input'}
          {...radioProps}
        />
        <label
          className={`radio-label ${dealClass} autotest-${props.id}`}
          htmlFor={props.id}
        >
          {props.label}
        </label>
        {props.planStateText &&
        <span className="plan-state-message">{props.planStateText}</span>
        }
        <p className={`radio-description ${stateClass}`}>
          {props.description}
        </p>
        {props.download && (
          <div className="plan-speeds">
            <div className="plan-speed-download">
              <PlanSpeedIndecator speedData={props.download} disabled={radioProps.disabled} />
            </div>
            <div className="plan-speed-upload">
              <PlanSpeedIndecator speedData={props.upload} disabled={radioProps.disabled} />
            </div>
          </div>
        )}
      </div>
      {props.price &&
      <div className={'col-sm-3 col-xs-12 additional-radio-text'}>
        <div className={`${dealClass} price-info`}>
          {props.previousPrice &&
          <div className={`previous-price ${stateClass}`}>
            Was {props.previousPrice}
          </div>
          }
          <div className="current-price">
            <div className={`additional-radio-text-title ${stateClass}`}>
              {props.price}
            </div>
            {props.additionalText2 &&
              <div className={`additional-radio-text-subtitle ${stateClass}`}>
                {props.additionalText2}
              </div>
          }
          </div>
          {
            props.planDealInfo &&
              <div className="price-deal-info">
                {props.planDealInfo}
              </div>
          }
          {
            props.planDealInfo &&
            <div className="price-deal-popup-info">
              <PlanDealInfoPopup />
            </div>
          }
        </div>
      </div>
      }
    </div>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  previousPrice: PropTypes.string,
  price: PropTypes.string,
  additionalText2: PropTypes.string,
  planDealInfo: PropTypes.string,
  description: PropTypes.string,
  planType: PropTypes.string,
  download: PropTypes.object,
  upload: PropTypes.object,
  isSpecial: PropTypes.bool,
  planStateText: PropTypes.string
};

export default RadioButton;



/** WEBPACK FOOTER **
 ** ./src/components/RadioButton/RadioButton.js
 **/